import { BaseService } from "core/service";
import { UserRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import Moment from "moment";

class LoginPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      error: null,
      enviromentSelector: false,
      passwordRecovery: {
        loading: false,
        open: false
      },
      email: "",
      password: "",
      enviroments: []
    };
  }

  async onStart() {
    this.enqueue({ loading: true });

    const response = await UserRepository.getLoggedInUser();
    if (response.success) {
      this.logged();
    }

    this.enqueue({ loading: false });
  }

  async getEnviroments(email) {
    const enviroments =  await UserRepository.getEnviromentsByUser(email)
    if(enviroments.success && enviroments.data) {
      const filteredEnvs =   enviroments.data && enviroments.data.user_domains.length > 0 ? 
      enviroments.data.user_domains.filter((domain) => domain.active) : []

      const spplitedEmail = email.split("@")
      if(spplitedEmail.length === 2 && spplitedEmail[1].includes("nexaas")) {
        filteredEnvs.push({
          id: null,
          name: "Padrão"
        })
      }

      return filteredEnvs
    } else {
      return {}
    }
  }

  async onLogin(email, password) {
    this.enqueue({ error: null, loading: true });

    const enviroments = await this.getEnviroments(email)

    if(enviroments.length === 1) {
      this.onSelectEnviroment(enviroments[0], email, password)
      return
    } else if(enviroments.length > 1){
      this.enqueue({ email, password, enviroments });
      this.openEnviromentSelector(enviroments)
      return
    } else {
      await this.login(email, password)
      return
    }
  }

  async login(email, password) {
    const response = await UserRepository.signIn(email, password);

    if (response.success) {
      BaseService.config({ authorizationToken: response.data.token });
      this.logged();
    } else if (response.fatal) {
      this.enqueue({
        error:
          "Não foi possível realizar o login. Tente novamente em alguns minutos."
      });
    } else {
      this.enqueue({ error: response.error });
    }

    this.enqueue({ loading: false });
  }

  onPasswordRecoveryOpen() {
    this.enqueue(vm => ({
      passwordRecovery: { ...vm.passwordRecovery, open: true }
    }));
  }

  onPasswordRecoveryClose() {
    this.enqueue(vm => ({
      passwordRecovery: { ...vm.passwordRecovery, open: false }
    }));
  }

  async submitPasswordRecovery(email) {
    this.enqueue(vm => ({
      passwordRecovery: { ...vm.passwordRecovery, loading: true }
    }));

    const result = await UserRepository.recoverPassword(email);
    if (result.success) {
      this.sendNotification({
        type: "success",
        content: "Email enviado com sucesso!"
      });
      this.enqueue(vm => ({
        passwordRecovery: { ...vm.passwordRecovery, open: false }
      }));
    } else if (result.error) {
      this.sendNotification({
        type: "error",
        title: "Ooopss...",
        content:
          "Este e-mail não está cadastrado no sistema. Verifique o e-mail inserido e tente novamente."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooopss...",
        content:
          "Não foi possível enviar o email de recuperação de senha no momento.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue(vm => ({
      passwordRecovery: { ...vm.passwordRecovery, loading: false }
    }));
  }

  onSignup() {
    this.navigateTo("app.signup");
  }

  onPasswordRecovery() {
    this.navigateTo("app.password-recovery");
  }

  openEnviromentSelector() {
    this.enqueue({ enviromentSelector: true });
  }

  async onSelectEnviroment(env, email, password) {
    if(env.id !== null) {
      await UserRepository.persistCurrentEnviromentToCookies(env.name)
    }
    this.enqueue({ enviromentSelector: false });
    await this.login(email, password)
  }

  async logged() {
    await this.verifyCertificateExpiryDate()
    this.navigateTo("app.history.dashboard");
  }

  async verifyCertificateExpiryDate() {
    const currentUser = await this.mRuntime.get("currentUser");
    const { certificate_info } = currentUser.company;
    const { expiry_date } = certificate_info;

    if (expiry_date) {
      const loginDate = Moment();
      const daysToExpiration = Moment(expiry_date).diff(
        loginDate,
        "days",
        false
      );
      const formattedExpiryDate = Moment(expiry_date).format("DD/MM/YYYY");
      let messageTense = "irá expirar";
      let titleTense = "está expirando";

      if (daysToExpiration <= 0) {
        titleTense = "expirou";
        messageTense = "expirou";
      }

      if (daysToExpiration < 30) {
        const title = `O seu Certificado Digital ${titleTense}`;
        const message = `O seu certificado digital ${messageTense} em ${formattedExpiryDate}, com o certificado vencido não é possível realizar emissão de notas fiscais.`;

        this.sendNotification({
          type: "error",
          title: title,
          content: message
        });
      }
    }
  }
}

export default LoginPresenter;



// WEBPACK FOOTER //
// ./src/components/app/login/presenter.js